/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// redux utils
import { createSlice } from '@reduxjs/toolkit';
// thunks
import {fetchChildPublishersData, fetchMcmAccountsData, saveMcmAccount} from '../thunks/mcm';



/* ========== ~~~~~~~~~~ MCM SLICE : REDUCER ~~~~~~~~~~ ========== */
const initialState = {
    childPublishers: [],
    mcmAccounts: {},
    loading: true,
    saveMcmAccountLoading: true,
    saveMcmAccountValidation: {}
}


export const mcmSlice = createSlice({
    name: 'mcm',
    initialState,
    reducers: {

    },
    extraReducers: builder => {
        builder
            .addCase(fetchChildPublishersData.pending, (state, action) => {
                state.status = 'pending'
                state.loading = true;
            })
            .addCase(fetchChildPublishersData.fulfilled, (state, action) => {
                const childPublishers = action.payload;
                if (childPublishers) {
                    for (let i=0; i < childPublishers.length; i++) {
                        let networkCode = childPublishers[i].childNetworkCode;
                        if(networkCode in state.mcmAccounts) {
                            childPublishers[i].gamRevenueShare = state.mcmAccounts[networkCode].gamRevenueShare;
                            childPublishers[i].overrideGamRevenueShare = state.mcmAccounts[networkCode].overrideGamRevenueShare;
                            childPublishers[i].insticatorAccountUUID = state.mcmAccounts[networkCode].accountUUID;
                            childPublishers[i].insticatorAccountDisplayName = state.mcmAccounts[networkCode].displayName;
                        }
                    }
                    state.childPublishers = childPublishers;
                }
                state.loading = false;
            })
            .addCase(fetchChildPublishersData.rejected, (state, action) => {
                state.status = 'rejected'
                state.loading = false;
            })
            .addCase(fetchMcmAccountsData.fulfilled, (state, action) => {
                const mcmAccounts = action.payload;
                if(mcmAccounts)
                    state.mcmAccounts = mcmAccounts;
            })
            .addCase(saveMcmAccount.pending, (state, action) => {
                state.saveMcmAccountLoading = true;
                state.saveMcmAccountValidation = {};
            })
            .addCase(saveMcmAccount.fulfilled, (state, action) => {
                state.saveMcmAccountValidation = action.payload;
                state.saveMcmAccountLoading = false;
            })
            .addCase(saveMcmAccount.rejected, (state, action) => {
                state.saveMcmAccountLoading = false;
            })
    }
});

// export const {  } = mcmSlice.actions;
export default mcmSlice.reducer;